// extracted by mini-css-extract-plugin
module.exports = {"grid":"adminWork-grid_grid__2c9ZF"};